import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "@/design-system/native";
import styles from "./FilterModal.module.scss";

export default function FilterModal({
  open,
  toggle,
  onSave,
  mode = "add", // "add" | "edit"
  initialData = null,
  icons,
}) {
  const [title, setTitle] = useState("");
  const [bookmark, setBookmark] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null);

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setTitle(initialData.title || "");
      setBookmark(initialData.bookmark || false);
      setSelectedIcon(initialData.icon || null);
    } else {
      setTitle("");
      setBookmark(false);
      setSelectedIcon(null);
    }
  }, [mode, initialData, open]);

  const handleSave = () => {
    if (!title) return;

    const newFilter = {
      id: mode === "edit" ? initialData.id : Date.now(),
      title,
      bookmark,
      icon: selectedIcon,
    };

    onSave?.(newFilter, mode);
    toggle();
  };

  return (
    <Modal isOpen={open} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {mode === "edit" ? "Edit Filter" : "New Filter"}
      </ModalHeader>
      <ModalBody>
        <div className={styles.field}>
          <label className={styles.label}>Title</label>
          <Input
            type="text"
            value={title}
            placeholder="Filter title"
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className={styles.field}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={bookmark}
              onChange={(e) => setBookmark(e.target.checked)}
            />
            Bookmark
          </label>
        </div>

        <div className={styles.iconHint}>Choose an icon</div>
        <div className={styles.iconGrid}>
          {Object.entries(icons).map(([id, Icon]) => (
            <div
              key={id}
              onClick={() => setSelectedIcon(id)}
              className={`${styles.iconCell} ${
                selectedIcon === id ? styles.iconCellSelected : ""
              }`}
            >
              <Icon size={18} /> {/* artık burası doğru çalışır */}
            </div>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
        <Button color="primary" onClick={handleSave}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}
